import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import ManageDeviceGroupsModal from 'zComponents/molecules/ManageDeviceGroupsModal';
import { Button, Col, Row, Tooltip } from 'zui/Antd';

const DevicesGroupPanelExtra = ({ deviceID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canUpdateGroup = useManagePermittedRoles('updateGroup');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canUpdateGroup) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('deviceGroups')) {
			setActiveKeys([...activeKeys, 'deviceGroups']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('deviceGroups')) {
					return [...prev, 'deviceGroups'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canUpdateGroup ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canUpdateGroup}
						/>
					</span>
				</Tooltip>
			</Col>
			<ManageDeviceGroupsModal visible={openModal} setVisible={handleCloseModal} deviceID={deviceID}>
				<div />
			</ManageDeviceGroupsModal>
		</Row>
	);
};

export default DevicesGroupPanelExtra;
